import { render, staticRenderFns } from "./AccountForget.vue?vue&type=template&id=607dac22&scoped=true&"
import script from "./AccountForget.vue?vue&type=script&lang=js&"
export * from "./AccountForget.vue?vue&type=script&lang=js&"
import style0 from "./AccountForget.vue?vue&type=style&index=0&id=607dac22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607dac22",
  null
  
)

export default component.exports